import BaseResource from './../base/BaseResource'
import TaskResource from './../tTask'

export default new class ResourceGetter {

  /**
   *
   * @param type
   * @return {*}
   */
  get (type) {
    switch (type) {
      case TaskResource.getResourceName():
        return TaskResource
      default:
        return new BaseResource(type)
    }

  }

}
